/**
 * @generated SignedSource<<0a85b8e01ea711aa992d13ddda759c9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type FunnelDetailsTableFilterButton_Query$variables = {};
export type FunnelDetailsTableFilterButton_QueryVariables = FunnelDetailsTableFilterButton_Query$variables;
export type FunnelDetailsTableFilterButton_Query$data = {
  readonly sources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null> | null;
  };
};
export type FunnelDetailsTableFilterButton_QueryResponse = FunnelDetailsTableFilterButton_Query$data;
export type FunnelDetailsTableFilterButton_Query = {
  variables: FunnelDetailsTableFilterButton_QueryVariables;
  response: FunnelDetailsTableFilterButton_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SourceConnection",
    "kind": "LinkedField",
    "name": "sources",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourceEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Source",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FunnelDetailsTableFilterButton_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FunnelDetailsTableFilterButton_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e7b3b2a5e084bdd8c662bbde23249918",
    "id": null,
    "metadata": {},
    "name": "FunnelDetailsTableFilterButton_Query",
    "operationKind": "query",
    "text": "query FunnelDetailsTableFilterButton_Query {\n  sources {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3424b82d4caa823d20ec365d4a85331";

export default node;
